import React from "react";
import { Table } from "react-bootstrap"
import Text from "../../../../_components/Text";
import LoadingContainer from "../../../../_components/LoadingContainer";
import Template from "./Template";
import { getPIS } from "../../../../api/products/taxes";
import { cstData } from "./Template"

export default props => {
    const [loading, setLoading] = React.useState(true)
    const [data, setData] = React.useState([])
    const [pis, setPIS] = React.useState([])
    const ref = React.useRef(null)

    function onSave() {
        const reload = () => window.location.reload()
        setTimeout(reload, 3000)
    }
    function onEdit(item) {
        setPIS({
            ...item
        })
    }
    function onClose() {
        setPIS({})
    }

    function init() {
        getPIS().then(resp => {
            setData(resp.reverse())
            setLoading(false)
        })
    }

    React.useEffect(init, [])

    return <React.Fragment>
        <LoadingContainer loading={loading} ref={ref}>
            <div className="container">
                <div className="row py-3">
                    <div className="col-12 my-3">
                        <Text as="h2"> Templates de PIS </Text>
                        <Template
                            show={pis.id != undefined}
                            data={pis}
                            onClose={onClose}
                            onSave={onSave} />
                    </div>
                    <div className="col-md-12">
                        <Table bordered hover>
                            <thead>
                                <tr>
                                    <th>Descrição</th>
                                    <th>CST PIS</th>
                                    <th>Alíquota</th>
                                    <th>Ações</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    data.map((pis, idx) => {
                                        const cst = cstData.find(item => item.value == pis.cst)
                                        return <tr key={`item-cst-listar-aqui${pis.id}${idx}`}>
                                            <td>
                                                {
                                                    pis.name
                                                }
                                            </td>
                                            <td>
                                                <span>
                                                    {
                                                        cst.value
                                                    }
                                                </span>
                                                &nbsp;-&nbsp;
                                                <span>
                                                    {
                                                        cst.label
                                                    }
                                                </span>
                                            </td>
                                            <td>
                                                {
                                                    pis.p_pis
                                                } %
                                            </td>
                                            <td>
                                                <i
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => { onEdit(pis) }}
                                                    className="fas fa-edit" />
                                            </td>
                                        </tr>
                                    })
                                }
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>
        </LoadingContainer>
    </React.Fragment>
}


// WEBPACK FOOTER //
// ./src/views/Fiscal/Taxes/PIS/index.jsx